/* istanbul ignore file */
export const DEF_FILTER_DEBOUNCE_MS = 500;
export const DEFAULT_PAGE_SIZE = 20;
export const DELETED_DISTRIBUTION_LABEL = "Deleted distribution";
